var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.layoutData.label != null
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-md-5 col-sm-5 col-xs-5 text-right",
                staticStyle: {
                  "font-weight": "bold",
                  "padding-right": "0",
                  "padding-left": "0",
                  "margin-top": "5px",
                  "text-decoration": "underline"
                }
              },
              [_vm._v(_vm._s(_vm.layoutData.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-7 col-sm-7 col-xs-7 text-right" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.enabledFields, function(field, index) {
        return _c("timesheet-fieldset", {
          key: index,
          attrs: { layout: field },
          on: { change: _vm.onChange }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }